import _Object$entries from "/app/node_modules/babel-runtime/core-js/object/entries";
export var isEmpty = function isEmpty() {
  for (var _len = arguments.length, valores = Array(_len), _key = 0; _key < _len; _key++) {
    valores[_key] = arguments[_key];
  }

  for (var i = 0; i < valores.length; i++) {
    var valor = valores[i];
    if ([null, undefined, "undefined", "null", "", 0, false, "false", []].includes(valor) || Array.isArray(valor) && valor.length === 0 || valor.constructor === Object && _Object$entries(valor).length === 0) {
      return true;
    }
  }
  return false;
};


//////////////////
// WEBPACK FOOTER
// ./src/mappers/Utils.js
// module id = ./src/mappers/Utils.js
// module chunks = 34